<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

export type CESGRolesProps = {
  data: {
    role: string;
  };
};

const props = defineProps<CESGRolesProps>();

const { t, te } = useI18n();

const translatedRole = computed(() => {
  const key = `roles.${props.data.role}`;
  return te(key) ? t(key) : props.data.role;
});
</script>

<template>
  <div>{{ translatedRole }}</div>
</template>
